import React from "react";
import "../../components/MicrochipList/MicrochipList.css";
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SearchIcon from '@mui/icons-material/Search';


const MicrochipList = ({userDetailResponse, setOpenProfile, openProfile}) => {
    //console.log(userDetailResponse);
  return (
    <div className="container-fluid">
      
      <div className="microchipList">
        <table>
          <tr className="microchipListHeading">
            <th>ID</th>
            <th>Product Name</th>
            <th>price</th>
           
            <th>Status</th>
            <th>Active</th>
            <th>Details</th>

          </tr>

<tr>
  <td>01</td>
  <td>Dog Microchip</td>
  <td>₹ 1,800</td>
  <td>
                <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                </button>
            </td>
            <td>
            <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} onClick={() => setOpenProfile(!openProfile)}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
            <td>
              <SearchIcon />
            </td>

</tr>

          {/* {userDetailResponse !== null ? (
    userDetailResponse.map((user) => (
        <tr key={user.id}>
            <td>1</td>
            <td>{user.name}</td>
            <td>{user.name}</td>
            <td>
                <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                </button>
            </td>
            <td>
            <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} onClick={() => setOpenProfile(!openProfile)}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
        </tr>
    ))
) : (
    <p>empty</p>
)} */}
         
          
        </table>
      </div>
    </div>
  );
};

export default MicrochipList;
